import React from "react";
import { useIntl } from "react-intl";
import SeoHead from "~/components/seo/SeoHead";

export default function GovernmentsPageSeo() {
  const intl = useIntl();

  return (
    <SeoHead
      title={intl.formatMessage({ defaultMessage: 'Local Government Innovators', id: 'G7xRda' })}
      description={intl.formatMessage({
        defaultMessage: 'Discover the most innovative local government teams around the world.', id: 'DNys4U',
      })}
    />
  );
}
